import React, { useContext, Component } from 'react';
import ChatBot from 'react-simple-chatbot';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import { Link,Redirect } from 'react-router-dom';
import './bot.css';
import { AuthContext } from '../../auth';


const Edufaq = () =>{
  return(
    <div style={{width:"100%"}}>
      <p className="lead">Click here to visit  <Link to='/education'>EDUCATION PAGE</Link></p>
      <p className="lead">Click here to visit  <Link to='/faq'>FAQ PAGE</Link></p>
    </div>
  )
}

const RehabCenters=()=>{
  return(
    <div style={{width:"100%"}}>
      <p className="lead">Here's information regarding <Link to='/rehab'>REHAB CENTERS</Link></p>
      
    </div>
  )
}

const OfflineHelp = ()=>{
  return(
    <div style={{width:"100%"}}>
      <p className="lead">We have online and offline services available to talk to a counsellor/psychologist. 
      <Link to={{
        pathname:'/login',
        re:'/offline'
      }}>Click here</Link> to go to their page to discuss further. </p>
      
    </div>
  )
}

const FaqTreat =()=>{
  return(
    <div style={{width:"100%"}}>
      <p className="lead">Here is a link to our <Link to='/faq'>FAQ PAGE</Link>, categorised to fit your situation, We recommend you to check the 'treatment' for more insight regarding recovery.</p>
    </div>
  )
}
class Substance extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        substanceuseoptions: ''
      };
    }
  
    componentWillMount() {
      const { steps } = this.props;
      const { substanceuseoptions} = steps;
  
      this.setState({ substanceuseoptions});
      console.log( substanceuseoptions);
      console.log("called");
    }
  
    render() {
      const { substanceuseoptions } = this.state;
      if(substanceuseoptions.value==='others'){
        return (
          
          
          <div style={{width:"100%"}}>
          
          <p>To know more about other Products visit</p>
          <p> <Link to='/education'><span className="text-primary">EDUCATION</span></Link></p>
  
  
        </div>
      )
      }
      else{
        return(
          <div style={{width:"100%"}}>
            <div className="media">
                  <Link target="blank" to={`/education/${substanceuseoptions.value}`}>
                  <div className="media-body mt-0">
                      <h5>{substanceuseoptions.message}</h5>
                      Click here to know more about {substanceuseoptions.value}
                  </div>
                  </Link>
                  
               </div>
            <p>To know more about other Products visit</p>
          <p> <Link to='/education'><span className="text-primary">EDUCATION</span></Link></p>
          </div>
        )
      }
      
  }
}

Substance.propTypes = {
  steps: PropTypes.object,
};

Substance.defaultProps = {
  steps: undefined,
};

// class Review extends Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       relation: '',
//       usesubstance: '',
//       howlong: '',
//       frequency: '',
//       soughttreatment: ''
//     };
//   }
//   componentWillMount() {
//     const { steps } = this.props;
//     const { relationoptions, userinputsubstance, howlongoptions, userinputfrequency, soughttreatmentoptions } = steps;

//     this.setState({
//       relation: relationoptions.value,
//       usesubstance: userinputsubstance.value,
//       howlong: howlongoptions.value,
//       frequency: userinputfrequency.value,
//       soughttreatment: soughttreatmentoptions.value
//     });
//   }
//   render() {
//     const { relation, usesubstance, howlong, frequency, soughttreatment } = this.state;
//     return (
//       <div style={{ width: '100%' }}>
//         <h3>Summary</h3>
//         <table>
//           <tbody>
//             <tr>
//               <td>Relation</td>
//               <td>{relation}</td>
//             </tr>
//             <tr>
//               <td>Substances Of use</td>
//               <td>{usesubstance}</td>
//             </tr>
//             <tr>
//               <td>How Long</td>
//               <td>{howlong}</td>
//             </tr>
//             <tr>
//               <td>Frequency</td>
//               <td>{frequency}</td>
//             </tr>
//             <tr>
//               <td>Sought Treatment</td>
//               <td>{soughttreatment}</td>
//             </tr>

//           </tbody>
//         </table>
//       </div>
//     );
//   }
// }
// Review.propTypes = {
//   steps: PropTypes.object,
// };

// Review.defaultProps = {
//   steps: undefined,
// };


let temp = 'login';

    
console.log(temp);
  

;

const theme = {
  background: '#f5f8fb',
  fontFamily: 'Open Sans',
  headerBgColor: '#6CB5FD',
  headerFontColor: '#fff',
  headerFontSize: '15px',
  botBubbleColor: '#6CB5FD',
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  userFontColor: '#4a4a4a',
};


const Bot = () => {
  console.log('bot');
  const [logedinuser, setLogedinuser] = useContext(AuthContext);
  console.log(temp);
  if (logedinuser) {
    temp = 'details';
    console.log(temp);
    
  }
  const steps = [
     {
      id: 'welcome',
      message: 'Hello, welcome to Connection Aid!\n\n What brings you here',
      trigger: 'welcomeoptions',
    },
  
    {
      id: 'welcomeoptions',
      options: [
        { value: 'familymember', label: 'I am concerned about a family member', trigger: '1.1' },
        { value: 'physicalpain', label: 'I am unsure of what i am feeling', trigger: '2.1' },
        { value: 'unsure', label: 'I am severely disturbed', trigger: '3.1' }
      ],
    },
    {
      id: '1.1',
      message: "Thank you for reaching out. Let's walk through this together. Who is the concerned person?",
      trigger: '1.1options'
    },
    {
      id: '1.1options',
      options: [
        { value: 'parent', label: 'Parent', trigger: '1.2' },
        { value: 'child', label: 'Child', trigger: '1.2' },
        { value: 'sibling', label: 'Sibling', trigger: '1.2' },
        { value: 'uncle/aunt', label: 'Uncle/Aunt', trigger: '1.2' },
        { value: 'cousin', label: 'Cousin', trigger: '1.2' },
        { value: 'friend', label: 'Friend', trigger: '1.2' },
      ]
    },
    {
      id: '1.2',
      message: 'Have you tried talking to them',
      trigger: '1.2options'
    },
    {
      id: '1.2options',
      options: [
        { value: 'yes', label: 'Yes', trigger: '1.4' },
        { value: 'no', label: 'No', trigger: '1.3' },
        { value: 'unresponsive', label: 'They are unresponsive to my attempts', trigger: 'unresponsive' }
      ]
    },
    {
      id:'unresponsive',
      component:<FaqTreat/>,
      trigger:'offlinehelp'
    },
    {
      id: '1.3',
      message: 'I believe you should. It could be hepful.',
      trigger: '1.3options'
    },
    {
      id: '1.3options',
      options: [
        { value: 'afraid', label: 'I am too afraid to talk to them', trigger: '1.4' },
        { value: 'wontwork', label: 'I am afraid it won\'t work out', trigger: '1.4' },
        { value: 'drugs', label: 'From what i observe they are into drugs', trigger: '1.4' }
      ]
    },
    {
      id: '1.4',
      message: 'Could you gather if they are addicted?',
      trigger: '1.4options'
    },
    {
      id: '1.4options',
      options: [
        { value: 'yes', label: 'Yes', trigger: '1.5' },
        { value: 'no', label: 'NO', trigger: 'faqgeneral' },
        { value: 'think', label: 'I think so', trigger: '1.5' }
      ]
    },
    {
      id:'faqgeneral',
      component:(
        <div style={{width:"100%"}}>
      <p className="lead">Here is a link to our <Link to='/faq'>FAQ PAGE</Link>, categorised to fit your situation, We recommend you to check the 'Common General Educative' category for more insight</p>
    </div>
      ),
      trigger:'1.6'
    },
    {
      id: '1.5',
      message: 'What is the substance of their choice?',
      trigger: 'substanceuseoptions'
    },
    {
      id: 'substanceuseoptions',
      options: [
        { value: 'marijuana', label: 'Marijuana', trigger: 'education' },
        { value: 'alcohol', label: 'Alcohol', trigger: 'education' },
        { value: 'cigarette', label: 'Cigarette', trigger: 'education' },
        { value: 'heroine', label: 'Heroine', trigger: 'education' },
        { value: 'cocaine', label: 'Cocaine', trigger: 'education' },
        { value: 'lsd', label: 'Lsd', trigger: 'education' },
        { value: 'mdma', label: 'MDMA', trigger: 'education' },
        { value: 'others', label: 'Others', trigger: 'education' },
      ]
    },
    {
      id: 'education',
      component: <Substance />,
      asMessage: false,
      trigger: '1.6'
    },
    {
      id: '1.6',
      message: 'Would the concerned person consider treatment?',
      trigger: '1.6options'
    },
    {
      id: '1.6options',
      options: [
        { value: '1', label: 'Yes', trigger: 'treatyes' },
        { value: '2', label: 'No', trigger: 'treatno' }
      ]
    },
    {
      id:"treatyes",
      component:<OfflineHelp/>,
      trigger:'rehab'
    },
    {
      id:"treatno",
      component:<FaqTreat/>,
      end:true
    },
    {
      id:'rehab',
      component:<RehabCenters/>,
      end:true
    },
    {
      id: '2.1',
      message: "Thank you for reaching out. Let's walk thorugh this together.",
      trigger: '2.1options'
    },
    {
      id: '2.1options',
      options: [
        { value: '1', label: "I can't say for certain why i feel this way", trigger: '2.2' },
        { value: '2', label: 'I can think of substance-use as a possible reason for it', trigger: '2.3' }
      ]
    },
    {
      id: '2.2',
      message: 'Do you think that substance-use could be a reason for how you feel?',
      trigger: '2.2options'
    },
    {
      id: '2.2options',
      options: [
        { value: '1', label: 'I have been into some substance but I\'m not sure if it can be a reason', trigger:'2.4' },
        { value: '2', label: 'Yes , I think so',trigger:'2.3' }
      ]
    },
    {
      id:'2.3',
      message:"What is the substance of your choice?",
      trigger:'substanceuseoptions'
    },
    {
      id:'2.4',
      message:'Would you like to head to the Education/FAQ page for more insight?',
      trigger:'2.4options'
    },
    {
      id:"2.4options",
      options:[
        {value:'1',label:'Yes',trigger:'edufaq'},
        {value:'2',label:'No',trigger:'offlinehelp'}
      ]
    },
    {
      id:'edufaq',
      component:<Edufaq/>,
      end:true
    },
    {
      id:'offlinehelp',
      component:<OfflineHelp/>,
      end:true
    },
    {
      id:'3.1',
      message:"We're sorry you're going through this. Thank you for reaching out. Let's walk through this together.",
      trigger:'3.1options'
    },
    {
      id:'3.1options',
      options:[
        {value:'1',label:"I can't say for certain why i am feeling this way",trigger:'3.2'},
        {value:'2',label:"I can think of substance-use as a possible reason for it.",trigger:'2.3'}
      ]
    },
    {
      id:"3.2",
      message:"Do you think that substance-use could be a reason for how you feel?",
      trigger:"3.2options"
    },
    {
      id:"3.2options",
      options:[
        {value:'1',label:"I have been into some substance but i am not sure if it can be a reason.",trigger:'2.4'},
        {value:'2',label:"Yes, I think so.",trigger:'2.3'}
      ]
    },
    
    {
  id: 'bye',
  message: 'Have a good day',
  end: true
}
    
    
  ];
  console.log(steps);
  return (

    <ThemeProvider theme={theme}>
      <ChatBot
        steps={steps} />
    </ThemeProvider>

  )

}

export default Bot;

// {
//   id: 'login',
//   component: (
//     <div style={{ width: '100%' }}>            
//       <h5>Please<Link to='/login'> Login</Link> to continue</h5>
//       <h5>Dont have an account?</h5>
//       <p><Link to='/register'>Click here to Register</Link></p>
//     </div>
//   ),
//   end:true,
// },
// {
//   id: 'details',
//   message: 'Please answer the following questions',
//   trigger: 'relation'
// },
// {
//   id: 'relation',
//   message: "What is your relationship with the dependent",
//   trigger: 'relationoptions'
// },
// {
//   id: 'relationoptions',
//   options: [
//     { value: 'parent', label: 'Parent', trigger: 'usesubstance' },
//     { value: 'child', label: 'Child', trigger: 'usesubstance' },
//     { value: 'sibling', label: 'Sibling', trigger: 'usesubstance' },
//     { value: 'uncle/aunt', label: 'Uncle/Aunt', trigger: 'usesubstance' }
//   ]
// },

// {
//   id: 'userinputsubstance',
//   user: true,
//   trigger: 'howlong'
// },
// {
//   id: 'howlong',
//   message: 'How long has their indulgence in the substance been?',
//   trigger: 'howlongoptions'
// },
// {
//   id: 'howlongoptions',
//   options: [
//     { value: 'few months', label: 'Few months', trigger: 'frequency' },
//     { value: 'an year', label: 'Year', trigger: 'frequency' },
//     { value: 'few years', label: 'Few Years', trigger: 'frequency' },
//     { value: 'many years', label: 'Many Years', trigger: 'frequency' }
//   ]
// },
// {
//   id: 'frequency',
//   message: 'What is the frequency of their use?',
//   trigger: 'userinputfrequency'
// },
// {
//   id: 'userinputfrequency',
//   user: true,
//   trigger: 'soughttreatment'
// },
// {
//   id: 'soughttreatment',
//   message: 'Have they sought treatment before',
//   trigger: 'soughttreatmentoptions'
// },
// {
//   id: 'soughttreatmentoptions',
//   options: [
//     { value: 'yes', label: 'Yes', trigger: 'summary' },
//     { value: 'no', label: 'No', trigger: 'summary' }
//   ]
// },
// {
//   id: 'summary',
//   message: 'Great! Check out your summary',
//   trigger: 'review',
// },
// {
//   id: 'review',
//   component: <Review />,
//   asMessage: true,
//   trigger: 'update',
// },
// {
//   id: 'update',
//   message: 'Would you like to update some field?',
//   trigger: 'updateoptions',
// },
// {
//   id: 'updateoptions',
//   options: [
//     { value: 'yes', label: 'Yes', trigger: 'update-yes' },
//     { value: 'no', label: 'No', trigger: 'bye' },
//   ],
// },
// {
//   id: 'update-yes',
//   message: 'What field would you like to update?',
//   trigger: 'update-fields',
// },
// {
//   id: 'update-fields',
//   options: [
//     { value: 'relationoptions', label: 'Relation', trigger: 'update-relation' },
//     { value: 'userinputsubstance', label: 'Substances of use', trigger: 'update-substance' },
//     { value: 'howlongoptions', label: 'How Long', trigger: 'update-howlong' },
//     { value: 'userinputfrequency', label: 'Frequency of use', trigger: 'update-frequency' },
//     { value: 'soughttreatmentoptions', label: 'Sought treatment', trigger: 'update-treatment' }
//   ],
// },

// {
//   id: 'update-relation',
//   update: 'relationoptions',
//   trigger: 'review',
// },
// {
//   id: 'update-substance',
//   update: 'userinputsubstance',
//   trigger: 'review',
// },
// {
//   id: 'update-howlong',
//   update: 'howlongoptions',
//   trigger: 'review',
// },
// {
//   id: 'update-frequency',
//   update: 'userinputfrequency',
//   trigger: 'review',
// },
// {
//   id: 'update-treatment',
//   update: 'soughttreatmentoptions',
//   trigger: 'review',
// },
// {
//   id: 'bye',
//   message: 'Have a god day',
//   end: true
// }